import {useEffect, useState} from 'react'
import {Trans} from '@lingui/macro'
import {t} from '@lingui/macro'

import './Main.css'
import SidebarSection from "./SidebarSection"
import BuyBoxB2B from "./BuyBoxB2B"
import BuyBoxB2C from "./BuyBoxB2C"
import RadioLines from "./RadioLines"
import RadioCards from "./RadioCards"
import Modal from "./Modal"
import RadioSwatches from "./RadioSwatches"
import RadioGrouped from "./RadioGrouped"
import { formatPrice, logDebug, handleResize } from './helpers/general'
import { getMattressesByWidth, getToppersByWidth, getSuitableFeet } from './helpers/main'
import { getMattressFilters, getTopperFilters, getFabricFilters, getBackOptions } from './helpers/filters'
import { completeConfigurationsOnly, checkStartConfiguration } from './helpers/checkData'
import {
    readModelsJson,
    readSizesJson, readConnectorsJson,
    readStacksSingleJson, readStacksDoubleJson, readMattressesJson, readToppersJson,
    readBackPartsJson,
    readFeetJson,
    readColorNames
} from './helpers/readJson'
import Preview from "./Preview";

function Main({expanded, allOptions, shopUrl, dataShopUrl}) {

    {/* ----- State-Variable für die gewählte Konfiguration ----- */}

    const
        [selected, setSelected] = useState({}),
        [triggerBedFabrics, setTriggerBedFabrics] = useState(0),   // wenn diese Variable geändert wird, sorgt ein Effect dafür, dass das Stoffvarianten-JSON neu geladen wird
        [triggerBackFabrics, setTriggerBackFabrics] = useState(0)
    function updateSelected(name, val) {
        // setzt selected auf den aktuellen Stand, wenn eine Option geändert wurde
        if (name === 'modelId') {
            setSelected(allOptions.defaultConfigurations[val])
            setTriggerBedFabrics(triggerBedFabrics+1)
            setTriggerBackFabrics(triggerBedFabrics+1)
        } else if (name === 'size') {
            let
                arrVal = val.split('_'),
                // passende Breitenvariante von Matratze und Topper ermitteln:
                frameQuantityNew = parseInt(arrVal[0]),
                widthNew = parseInt(arrVal[1]),
                mattressQuantityNew = (selected.mattressQuantity > frameQuantityNew) ? 1 : selected.mattressQuantity,
                topperQuantityNew = (selected.topperQuantity > frameQuantityNew) ? 1 : selected.topperQuantity,
                backQuantityNew = (selected.backQuantity > frameQuantityNew) ? 1 : selected.backQuantity,
                mattressWidth = (mattressQuantityNew < frameQuantityNew) ? widthNew * 2 : widthNew,
                topperWidth = (topperQuantityNew < frameQuantityNew) ? widthNew * 2 : widthNew,
                bedframeIdNew = sizes[frameQuantityNew + '_' + frameQuantityNew * widthNew]?.oxid,
                bedframeParentIdNew = sizes[frameQuantityNew + '_' + frameQuantityNew * widthNew]?.parent,
                feetIdNew,
                numberFeetNeeded
            if ( !selected || !selected['5feetFrom'] || (widthNew < parseInt(selected['5feetFrom'])) ) {
                numberFeetNeeded = 4
            } else {
                numberFeetNeeded = 5
            }
            // Passende Fußset-Variante je nach Bettbreite ermitteln:
            allOptions.footSets.forEach(function(footSet) {
                if (footSet.articleId === selected.feetParentId) {
                    footSet.variants.forEach(function(variant) {
                        if (!variant.wheels) {
                            variant.wheels = '0'
                        }
                        if (
                            feet[selected.feetParentId].variants[selected.feetId].height === variant.height
                            &&
                            feet[selected.feetParentId].variants[selected.feetId].wheels === variant.wheels
                            &&
                            +variant.wheels + +variant.feet === numberFeetNeeded
                        ) {
                            feetIdNew = variant.articleId
                        }
                    })
                }
            })
            if (!feetIdNew) {
                feetIdNew = selected.feetId     // Fallback, falls etwas schief geht
                console.warn('Kein passendes Fußset gefunden.')
            }
            setSelected({
                ...selected,
                ...{frameQuantity: frameQuantityNew},
                ...{bedframeId: bedframeIdNew},
                ...{bedframeParentId: bedframeParentIdNew },
                ...{width: widthNew},
                ...{mattressId: (mattressQuantityNew) ? allOptions.mattressConfiguration.mattresses.find(m => m.articleId === selected.mattressParentId).variants.find(v => v.width === mattressWidth).articleId : null},
                ...{mattressQuantity: mattressQuantityNew},
                ...{topperId: (topperQuantityNew) ? allOptions.mattressConfiguration.toppers.find(t => t.articleId === selected.topperParentId).variants.find(v => v.width === topperWidth).articleId : null},
                ...{topperQuantity: topperQuantityNew},
                ...{backQuantity: backQuantityNew},
                ...{feetId: feetIdNew}
            });
            setTriggerBedFabrics(triggerBedFabrics+1)
            setTriggerBackFabrics(triggerBackFabrics+1)
        } else if (name === 'stack') {
            let
                arrVal = val.split('_'),
                mattressQuantityNew = parseInt(arrVal[0][0]),
                topperQuantityNew = parseInt(arrVal[1][0]),
                mattressWidth = (mattressQuantityNew < selected.frameQuantity) ? selected.width * 2 : selected.width,
                topperWidth = (topperQuantityNew < selected.frameQuantity) ? selected.width * 2 : selected.width
            setSelected({
                ...selected,
                ...{mattressId: (mattressQuantityNew) ? allOptions.mattressConfiguration.mattresses.find(m => m.articleId === selected.mattressParentId).variants.find(v => v.width === mattressWidth).articleId : null},
                ...{mattressQuantity: mattressQuantityNew},
                ...{topperId: (topperQuantityNew) ? allOptions.mattressConfiguration.toppers.find(t => t.articleId === selected.topperParentId).variants.find(v => v.width === topperWidth).articleId : null},
                ...{topperQuantity:topperQuantityNew }
            });
        } else if (name === 'mattressId') {
            let mattressParentNew
            allOptions.mattressConfiguration.mattresses.forEach(function(m) {
                let mattressParent = m.variants.find(v => v.articleId === val)
                if (mattressParent) {
                    mattressParentNew = m.articleId
                }
            })
            setSelected({
                ...selected,
                ...{mattressId: val},
                ...{mattressParentId: mattressParentNew}
            });
        } else if (name === 'topperId') {
            let topperParentNew
            allOptions.mattressConfiguration.toppers.forEach(function(t) {
                let topperParent = t.variants.find(v => v.articleId === val)
                if (topperParent) {
                    topperParentNew = t.articleId
                }
            })
            setSelected({
                ...selected,
                ...{topperId: val},
                ...{topperParentId: topperParentNew}
            });
        } else if (name === 'feetId') {
            let feetParentIdNew
            allOptions.footSets.forEach(function(f) {
                let feetParent = f.variants.find(v => v.articleId === val)
                if (feetParent) {
                    feetParentIdNew = f.articleId
                }
            })
            setSelected({
                ...selected,
                ...{feetId: val},
                ...{feetParentId: feetParentIdNew}
            });
        } else {
            setSelected({
                ...selected,
                ...{[name]: val}
            });
        }
    }



    {/* ----- JSON-Daten einlesen ----- */}

    let
        models = {},
        sizes = {},
        connectors = {},
        stacks = {},
        mattresses = {},
        toppers = {},
        backs = {},
        feet = {}

    let colorNames = [],        // enthält die Farbnamen; zum Erzeugen der Farbfilter
        colorFamilies = {},     // Zuordnung Farbcode - Farbname
        topperFoamTypes = {}    // Schaumtypen der Topper, für den Filter

    let artNum2Name = {}   // enthält die Dateinamen-Elemente zu den Artikelnummern

    const [fabrics, setFabrics] = useState({})
    const [artNum2NameFabric, setArtNum2NameFabric] = useState(null)
    function loadBedFabrics() {
        // lädt die Stoffoptionen-JSON
        if (!selected.modelArtNum) return
        const fetchBedFabrics = window.offline ? `dummyFabrics-f05-090-${window.langNum}.json` : `${window.dataShopUrl}${window.apiPath}boxconfigs/beds/${selected.modelArtNum}/${selected.width}?language=${window.langNum}${window.forceDb}&b2=${window.b2b ? 'b' : 'c'}`
        logDebug(`Betten aus: ${fetchBedFabrics}`)
        fetch(fetchBedFabrics,
           {credentials: 'include'}
        )
        .then(res => res.json())
        .then(data => {
                setFabrics(data?.fabrics)
                loadBedFabricsByVariant(data?.fabrics)
            }
        )
    }
    const [bedFabricsByVariant, setBedFabricsByVariant] = useState([])    // flache Struktur, damit man Daten direkt über die Artikelnummer abfragen kann
    function loadBedFabricsByVariant(dataFabrics) {
        if (!dataFabrics || !Object.keys(dataFabrics).length) return
        let
            bedFabricsByVariantNew = [],
            artNum2NameFabricNew = {}
        for (const type in dataFabrics) {
            for (const option in dataFabrics[type].options) {
                for (const color in dataFabrics[type].options[option].colors) {
                    bedFabricsByVariantNew[dataFabrics[type].options[option].name, dataFabrics[type].options[option].colors[color].articleId] = {
                        name: dataFabrics[type].options[option].name + ' ' + dataFabrics[type].options[option].colors[color].variant + ' (' + type + ')',
                        price: dataFabrics[type].options[option].colors[color].price,
                    }
                    artNum2NameFabricNew[dataFabrics[type].options[option].colors[color].articleId] = dataFabrics[type].options[option].name.toLowerCase().replace(' ', '_') + '_' + dataFabrics[type].options[option].colors[color].variant.split('/')[0]
                }
            }
        }
        setArtNum2NameFabric(artNum2NameFabricNew)
        setBedFabricsByVariant(bedFabricsByVariantNew)
    }

    const [backFabrics, setBackFabrics] = useState({})
    const [artNum2NameBackFabric, setArtNum2NameBackFabric] = useState(null)
    function loadBackFabrics() {
        // lädt die Stoffoptionen-JSON für die Rückenteile
        if (!selected.backId) return
        const fetchBackFabrics = window.offline ?`dummyBackFabrics-f05-090-${window.langNum}.json` : `${window.dataShopUrl}${window.apiPath}boxconfigs/backparts/${selected.backId}/${(selected.frameQuantity > selected.backQuantity) ? selected.width * 2 : selected.width}?language=${window.langNum}&b2=${window.b2b ? 'b' : 'c'}`
        logDebug(`Rückenteile aus: ${fetchBackFabrics}`)
        fetch(fetchBackFabrics,
           {credentials: 'include'}
        )
        .then(res => res.json())
        .then(data => {
                setBackFabrics(data?.fabrics)
                loadBackFabricsByVariant(data?.fabrics)
            }
        )
    }
    const [backFabricsByVariant, setBackFabricsByVariant] = useState([])    // flache Struktur, damit man Daten direkt über die Artikelnummer abfragen kann
    function loadBackFabricsByVariant(dataBackFabrics) {
        if (!dataBackFabrics || !Object.keys(dataBackFabrics).length) return
        let
            backFabricsByVariantNew = [],
            artNum2NameBackFabricNew = {}
        for (const type in dataBackFabrics) {
            for (const option in dataBackFabrics[type].options) {
                for (const color in dataBackFabrics[type].options[option].colors) {
                    backFabricsByVariantNew[dataBackFabrics[type].options[option].name, dataBackFabrics[type].options[option].colors[color].articleId] = {
                        name: dataBackFabrics[type].options[option].name + ' ' + dataBackFabrics[type].options[option].colors[color].variant + ' (' + type + ')',
                        price: dataBackFabrics[type].options[option].colors[color].price,
                        fabricName: dataBackFabrics[type].options[option].name
                    }
                    artNum2NameBackFabricNew[dataBackFabrics[type].options[option].colors[color].articleId] = dataBackFabrics[type].options[option].name.toLowerCase().replace(' ', '_') + '_' + dataBackFabrics[type].options[option].colors[color].variant.split('/')[0]
                }
            }
        }
        setArtNum2NameBackFabric(artNum2NameBackFabricNew)
        setBackFabricsByVariant(backFabricsByVariantNew)
    }

    const [restrictions, setRestrictions] = useState([])
    function fetchRestrictions() {
        // Einschränkungen einlesen: Welche Optionen sind nicht mit der aktuellen Konfiguration kompatibel?
        if (window.offline) return
        let restrictionsNew = {}
        const restrictionsUrl = `${window.dataShopUrl}${window.apiPath}articlerestrictions/${selected.backFabricId},${selected.backId},${selected.connectorId},${selected.fabricId},${selected.feetId},${selected.feetParentId},${selected.mattressId},${selected.mattressParentId},${selected.modelId},${selected.topperId},${selected.topperParentId}`
        logDebug(`Einschränkungen aus: ${restrictionsUrl}`)
        fetch(restrictionsUrl,
           {credentials: 'include'}
        )
        .then(res => res.json())
        .then(data => {
                for (const block in data) {
                    for (const entry in data[block]) {
                        if (data[block][entry]) {
                            restrictionsNew[data[block][entry]] = block
                        }
                    }
                }
                // Wenn keine Topper zur Auswahl stehen, Umschalten auf Bett ohne Topper:
                let toppersLeft = []
                for (const topper in toppers) {
                    if (!restrictionsNew[topper]) {
                        toppersLeft.push(topper)
                    }
                }
                if (toppersLeft.length === 0) {
                    selected.topperQuantity = 0
                    restrictionsNew['1mattress_1topper'] = true
                    restrictionsNew['2mattress_1topper'] = true
                    restrictionsNew['2mattress_2topper'] = true
                }
                setRestrictions(restrictionsNew)
            }
        )
    }

    const configuration = Object.keys(selected || {}).length ? selected : allOptions.selectedConfiguration

    if (!Array.isArray(allOptions)) {   // d.h. wenn allOptions Werte enthält

        // JSON-Daten überprüfen:
        allOptions = completeConfigurationsOnly(allOptions)
        allOptions = checkStartConfiguration(allOptions)

        // Werte in Objekte einlesen:
        models = readModelsJson(allOptions)
        sizes = readSizesJson(allOptions, configuration)
        connectors = readConnectorsJson(allOptions)
        for (const [key, val] of Object.entries(sizes)) {
            Object.assign(
                val,
                {name: <>{(val.quantity === 2) ? '2×' : ''}{(val.type === 'double') ? (val.width/2) : val.width} cm {(val.quantity === 2) ? <Trans>Doppelbett</Trans> : <Trans>Einzelbett</Trans>}</>}
            )
        }

        if (configuration.frameQuantity === 1) {
            stacks = readStacksSingleJson(allOptions)
        } else {
            stacks = readStacksDoubleJson(allOptions)
        }
        mattresses = getMattressesByWidth(configuration, readMattressesJson(allOptions))
        toppers = getToppersByWidth(configuration, readToppersJson(allOptions))

        backs = readBackPartsJson(allOptions, artNum2Name)

        feet = getSuitableFeet(configuration, readFeetJson(allOptions, artNum2Name), selected)

        colorNames = readColorNames(allOptions, colorFamilies)
    }

    const mattressFilters = getMattressFilters()
    const [activeMattressFilters, setActiveMattressFilters] = useState({})
    function updateMattressFilters(name, checked) {
        setActiveMattressFilters({
            ...activeMattressFilters,
            ...{[name]: checked}
        });
    }

    const topperFilters = getTopperFilters(topperFoamTypes)
    const [activeTopperFilters, setActiveTopperFilters] = useState({})
    function updateTopperFilters(name, checked) {
        setActiveTopperFilters({
            ...activeTopperFilters,
            ...{[name]: checked}
        });
    }

    let fabricFilters = getFabricFilters(colorNames)
    const [activeFabricFilters, setActiveFabricFilters] = useState({})
    function updateFabricFilters(name, checked) {
        setActiveFabricFilters({
            ...activeFabricFilters,
            ...{[name]: checked}
        });
    }

    let backOptions = getBackOptions()



    {/* ----- Effects ----- */}

    useEffect(() => {
        setSelected(allOptions.selectedConfiguration)
    }, [allOptions])

    useEffect(() => {
        if (allOptions.length !== 0) {
            loadBedFabrics()
            loadBackFabrics()
        }
    }, [selected?.modelId, selected?.width])

    useEffect(() => {
        if (allOptions.length !== 0) {
            loadBackFabrics()
        }
    }, [selected?.backId, selected?.backQuantity])

    useEffect(() => {
        loadBedFabrics()
    }, [triggerBedFabrics])

    useEffect(() => {
        loadBackFabrics()
    }, [triggerBackFabrics])

    useEffect(() => {
        if (allOptions.length !== 0) {
            fetchRestrictions()
        }
    }, [selected])

    useEffect(() => {
        window.addEventListener("resize", handleResize, false)
        handleResize()
    }, [])



    {/* ----- State-Variablen und Funktionen für die Auswahl-Widgets ----- */}

    const [expandedSection, setExpandedSection] = useState(expanded)
    function openSection(id) {
        setExpandedSection(id)
    }

    const [modalMattressIsOpen, setModalMattressIsOpen] = useState(false)
    function modalMattressOpen()  {
        setModalMattressIsOpen(true)
    }
    function modalMattressClose()  {
        setModalMattressIsOpen(false)
        setActiveMattressFilters({})
    }
    const [modalTopperIsOpen, setModalTopperIsOpen] = useState(false)
    function modalTopperOpen()  {
        setModalTopperIsOpen(true)
    }
    function modalTopperClose()  {
        setModalTopperIsOpen(false)
        setActiveTopperFilters({})
    }

    const [modalFabricIsOpen, setModalFabricIsOpen] = useState(false)
    function modalFabricOpen()  {
        setModalFabricIsOpen(true)
    }
    function modalFabricClose()  {
        setModalFabricIsOpen(false)
        setActiveFabricFilters({})
    }

    const [modalBackFabricIsOpen, setModalBackFabricIsOpen] = useState(false)
    function modalBackFabricOpen()  {
        setModalBackFabricIsOpen(true)
    }
    function modalBackFabricClose()  {
        setModalBackFabricIsOpen(false)
        setActiveFabricFilters({})
    }

    const [modalFeetIsOpen, setModalFeetIsOpen] = useState(false)
    function modalFeetOpen()  {
        setModalFeetIsOpen(true)
    }
    function modalFeetClose()  {
        setModalFeetIsOpen(false)
    }



    {/* ----- Ausgabe generieren ----- */}

    return (
        <div className={"App " + (window.b2b === true ? "b2b" : "b2c")}>
            {(allOptions.length !== 0) ?
                <Preview selected={selected} artNum2Name={artNum2Name} artNum2NameFabric={artNum2NameFabric} artNum2NameBackFabric={artNum2NameBackFabric} shopUrl={dataShopUrl} feetWheels={selected ? feet[selected.feetParentId].variants[selected.feetId].wheels : ''} />
            :
                <Preview/>
            }
            <aside className="sidebar" id="sidebar">

                <header>
                    <a href={window.b2b === true ? 'https://www.fbf-bedandmore.de/' : 'https://www.fbf-home.de/'} className="icon home"><i className="fas fa-home"></i></a>
                    {window.b2b === true ?
                        <ul className='languages'>
                            <li><a href="?l=de" href={"?l=de" + (window.configId ? "&id="+window.configId : '') + (window.debug ? "&debug=true" : '') + (window.offline ? "&offline=true" : '')} className={(window.lang==='de') ? 'lang active' : 'lang'}>DE</a></li>
                            <li><a href="?l=de" href={"?l=en" + (window.configId ? "&id="+window.configId : '') + (window.debug ? "&debug=true" : '') + (window.offline ? "&offline=true" : '')} className={(window.lang==='en') ? 'lang active' : 'lang'}>EN</a></li>
                        </ul>
                    : '' }
                </header>

                {((allOptions.length !== 0) && (selected)) ?
                    <main>

                        {/* ----- Auswahl des Modells ----- */}
                        <SidebarSection
                            id='model'
                            expanded={expandedSection==='model' ? 'expanded' : null}
                            name={<Trans>Modell</Trans>}
                            summary={[{text:models[selected.modelId].name}]}
                            editFunction={() => openSection('model')}
                            proceedFunction={() => openSection('size')}
                        >
                            <div className="options">
                                <RadioLines name='modelId' options={models} selected={selected.modelId} onChange={updateSelected} />
                            </div>
                        </SidebarSection>

                        {/* ----- Auswahl von Größe und ggf. Verbinder ----- */}
                        <SidebarSection
                            id='size'
                            expanded={expandedSection==='size' ? 'expanded' : null}
                            name={<Trans>Größe</Trans>}
                            summary={[
                                {text:( (selected.frameQuantity > 1) ? <>{selected.frameQuantity} <Trans>Einzelbetten je</Trans> {selected.width}×200&nbsp;cm</> : <><Trans>Einzelbett</Trans> {selected.width}×200&nbsp;cm</>)},
                                {text:( (selected.frameQuantity > 1) ? <><Trans>Verbinder</Trans>: {connectors[selected.connectorId].name}</> : '')}
                            ]}
                            editFunction={() => openSection('size')}
                            proceedFunction={() => openSection('fabric-color')}
                        >
                            <div className="options">
                                <select name="size" id="size" value={selected.frameQuantity + '_' + selected.width} onChange={e => updateSelected(e.target.name, e.target.value)}>
                                    {Object.keys(sizes).map((option, i) => (
                                        <option key={i} value={sizes[option].id}>{sizes[option].name} (<Trans>ab</Trans> {formatPrice(sizes[option].price)})</option>
                                    ))}
                                </select>
                                <div className='note'><i className="fas fa-exclamation-circle"></i>&nbsp; <Trans><b>Lieferung in einem Stück.</b> Bitte beachten Sie die Maße für die Anlieferung ins Hotelzimmer.</Trans></div>
                                {window.b2b && (selected.frameQuantity > 1) ?
                                    <div>
                                        <h3>
                                            <Trans>Verbinder</Trans>
                                        </h3>
                                        <RadioCards name='connectorId' options={connectors} restrictions={restrictions} selected={selected.connectorId} onChange={updateSelected} />
                                    </div>
                                : '' }
                            </div>
                        </SidebarSection>

                        {/* ----- Auswahl des Bezugs ----- */}
                        <SidebarSection
                            id='fabric-color'
                            expanded={expandedSection==='fabric-color' ? 'expanded' : null}
                            name={<Trans>Stoff & Farbe</Trans>}
                            summary={[
                                {
                                    text:bedFabricsByVariant[selected.fabricId] ? bedFabricsByVariant[selected.fabricId].name : '...',
                                    price:bedFabricsByVariant[selected.fabricId] ? ( '+ ' + formatPrice(selected.frameQuantity * bedFabricsByVariant[selected.fabricId].price) ) : '...'
                                }
                            ]}
                            editFunction={() => openSection('fabric-color')}
                            proceedFunction={() => openSection('mattress-topper')}
                        >
                            <div className="options">
                                <div id="fabricButton" className="show">
                                    <button className="openModal btnSecondary" onClick={modalFabricOpen}>{bedFabricsByVariant[selected.fabricId] ? bedFabricsByVariant[selected.fabricId].name + ' (' + formatPrice(selected.frameQuantity * bedFabricsByVariant[selected.fabricId].price) + ')' : '...'}</button>
                                </div>
                                {modalFabricIsOpen ?
                                    <Modal title={<Trans>Stoff und Farbe wählen</Trans>} id='fabric' filters={fabricFilters} notes={[<Trans>Die angezeigten Preise stellen den Preis des von Ihnen gewählten Betts (Modell, Größe) mit dem jeweiligen Bezug dar.</Trans>, <Trans>Bei dieser Auswahl handelt es sich um festverpolsterte Stoffe. Möchten Sie lieber einen Bettschal oder einen Volant, dann kontaktieren Sie uns bitte für ein individuelles Angebot.</Trans>]} onClose={modalFabricClose} onFilterChange={updateFabricFilters}>
                                        <RadioSwatches name='fabricId' options={fabrics} selected={selected.fabricId} onChange={updateSelected} activeFilters={activeFabricFilters} colorFamilies={colorFamilies}/>
                                    </Modal>
                                : null}
                            </div>
                        </SidebarSection>

                        {/* ----- Auswahl von Matratze und Topper ----- */}
                        <SidebarSection
                            id='mattress-topper'
                            expanded={expandedSection==='mattress-topper' ? 'expanded' : null}
                            name={<Trans>Matratze & Topper</Trans>}
                            summary={[
                                {
                                    text:
                                        (selected.mattressQuantity > 0)
                                            ? (
                                                (selected.mattressQuantity > 1)
                                                    ? (selected.mattressQuantity+'× ')
                                                    : ''
                                            ) + mattresses[selected.mattressId].name+''
                                            : (<Trans>ohne Matratze & Topper</Trans>),
                                    price:
                                        (selected.mattressQuantity > 0)
                                            ? (
                                                '+ ' + formatPrice(selected.mattressQuantity*mattresses[selected.mattressId].price)
                                            )
                                            : ''
                                },
                                {
                                    text:
                                        (selected.topperQuantity > 0)
                                            ? (
                                                (selected.topperQuantity > 1)
                                                    ? (selected.topperQuantity+'× ')
                                                    : ''
                                            ) + toppers[selected.topperId].name
                                            : '',
                                    price:
                                        (selected.topperQuantity > 0)
                                            ? (
                                                '+ ' + formatPrice(selected.topperQuantity*toppers[selected.topperId].price)
                                            )
                                            : ''
                                },
                            ]}
                            editFunction={() => openSection('mattress-topper')}
                            proceedFunction={() => openSection('back')}
                        >
                            <div className="options">
                                <RadioCards name='stack' options={stacks} selected={selected.mattressQuantity+'mattress_'+selected.topperQuantity+'topper'} restrictions={restrictions} onChange={updateSelected} />
                                {selected.mattressQuantity > 0 ?
                                    <div id="mattressButton" className="show">
                                        <h3><Trans>Matratze</Trans></h3>
                                        <button className="openModal btnSecondary" onClick={modalMattressOpen}>{(selected.mattressQuantity > 1) ? (selected.mattressQuantity+'× ') : ''}{mattresses[selected.mattressId].name} ({formatPrice(selected.mattressQuantity*mattresses[selected.mattressId].price)})</button>
                                    </div>
                                : null}
                                {modalMattressIsOpen ?
                                    <Modal title={<Trans>Matratze wählen</Trans>} id='mattress' filters={mattressFilters} onClose={modalMattressClose} onFilterChange={updateMattressFilters}>
                                        <RadioCards name='mattressId' options={mattresses} selected={selected.mattressId} onChange={updateSelected} activeFilters={activeMattressFilters} restrictions={restrictions} />
                                    </Modal>
                                : null}
                                {selected.topperQuantity > 0 ?
                                    <div id="topperButton" className="show">
                                        <h3><Trans>Topper</Trans></h3>
                                        {mattresses[selected.mattressId].hardness === 'H2' ?
                                            <div className="note"><i className="fas fa-exclamation-circle"></i>&nbsp; <Trans>Sie haben eine Matratze mit dem Härtegrad H2 gewählt. Wir empfehlen Ihnen hier keinen Topper zu wählen, da die Kombination zu weich werden kann. Bitte ändern Sie ggf. den Aufbau.</Trans></div>
                                        : '' }
                                        <button className="openModal btnSecondary" onClick={modalTopperOpen}>{( (selected.topperQuantity > 1) ? (selected.topperQuantity+'× ') : '' ) + toppers[selected.topperId].name} ({formatPrice(selected.topperQuantity*toppers[selected.topperId].price)})</button>
                                    </div>
                                : null}
                                {modalTopperIsOpen ?
                                    <Modal title={<Trans>Topper wählen</Trans>} id='topper' filters={topperFilters} onClose={modalTopperClose} onFilterChange={updateTopperFilters}>
                                        <RadioCards name='topperId' options={toppers} selected={selected.topperId} onChange={updateSelected} activeFilters={activeTopperFilters} restrictions={restrictions} />
                                    </Modal>
                                : null}
                            </div>
                        </SidebarSection>

                        {/* ----- Auswahl des Rückenteils und von dessen Bezug ----- */}
                        <SidebarSection
                            id='back'
                            expanded={expandedSection==='back' ? 'expanded' : null}
                            name={<Trans>Rückenteil</Trans>}
                            summary={[
                                {
                                    text:
                                        (selected.backId)
                                            ? backFabricsByVariant[selected.backFabricId]
                                                ? ( ( (selected.backQuantity) > 1 ? '2× ' : '' ) + backs[selected.backId].name + ', ' + backFabricsByVariant[selected.backFabricId].name)
                                                : '...'
                                            : '(' + t`ohne Rückenteil` + ')',

                                    price:
                                        (selected.backId)
                                            ? backFabricsByVariant[selected.backFabricId]
                                                ? ( '+ ' + formatPrice(selected.backQuantity * backFabricsByVariant[selected.backFabricId].price) )
                                                : '...'
                                            : ''

                                }
                            ]}
                            editFunction={() => openSection('back')}
                            proceedFunction={() => openSection('feet')}
                        >
                            <div className="options">
                                <div><RadioCards name='backId' options={backs} selected={selected.backId} onChange={updateSelected} /></div>
                                {( (selected.backId) && (selected.frameQuantity === 2) && backOptions ) ?
                                    <div>
                                        <h3><Trans>Ausführung</Trans></h3>
                                        <select name="backQuantity" id="size" value={selected.backQuantity} onChange={e => updateSelected(e.target.name, e.target.value)}>
                                            {backOptions.map((version, i) => (
                                                <option key={i} value={version.key}>{version.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                : ''}
                                { window.b2b && (selected.backId) ?
                                    <div>
                                        {(backFabricsByVariant[selected.backFabricId] && backFabricsByVariant[selected.backFabricId].fabricName === 'Maine') ?
                                            <div className="note"><i className="fas fa-exclamation-circle"></i>&nbsp; <Trans>Sie haben ein Rückenteil mit dem Bezugstoff Maine gewählt. Wir empfehlen Ihnen, einen anderen Bezugstoff zu wählen, da das Maine-Kunstleder nur für Bettboxen geeignet ist.</Trans></div>
                                        : '' }
                                        <h3><Trans>Stoff & Farbe Rückenteil</Trans></h3>
                                        <div id="backFabricButton" className="show">
                                            <button className="openModal btnSecondary" onClick={modalBackFabricOpen}>{backFabricsByVariant[selected.backFabricId] ? backFabricsByVariant[selected.backFabricId].name + ' (' + formatPrice(selected.backQuantity * backFabricsByVariant[selected.backFabricId].price) + ')': '...'}</button>
                                        </div>
                                    </div>
                                : '' }
                                {modalBackFabricIsOpen ?
                                    <Modal title={<Trans>Stoff und Farbe für das Rückenteil wählen</Trans>} id='backFabric' filters={fabricFilters} onClose={modalBackFabricClose} onFilterChange={updateFabricFilters}>
                                        <RadioSwatches name='backFabricId' options={backFabrics} selected={selected.backFabricId} onChange={updateSelected} activeFilters={activeFabricFilters} colorFamilies={colorFamilies}/>
                                    </Modal>
                                : null}
                            </div>
                        </SidebarSection>

                        {/* ----- Auswahl des Fußsets ----- */}
                        <SidebarSection
                            id='feet'
                            expanded={expandedSection==='feet' ? 'expanded' : null}
                            name={<Trans>Füße & Rollen</Trans>}
                            summary={[
                                {text:((selected.frameQuantity > 1) ? (selected.frameQuantity+'× ') : '') + feet[selected.feetParentId].variants[selected.feetId].nameFull, price: '+ ' + formatPrice(selected.frameQuantity*feet[selected.feetParentId].variants[selected.feetId].price)}
                            ]}
                            editFunction={() => openSection('feet')}
                            order='last'
                        >
                            <div className="options">
                                <div id="feetButton" className="show">
                                    <button className="openModal btnSecondary" onClick={modalFeetOpen}>{(selected.frameQuantity > 1) ? (selected.frameQuantity+'× ') : ''}{feet[selected.feetParentId].variants[selected.feetId].nameFull + ' (' + formatPrice(selected.frameQuantity*feet[selected.feetParentId].variants[selected.feetId].price) + ')'}</button>
                                </div>
                                {modalFeetIsOpen ?
                                    <Modal title={<Trans>Fußset wählen</Trans>} id='feet' onClose={modalFeetClose}>
                                        <RadioGrouped name='feetId' options={feet} selected={selected.feetId} onChange={updateSelected} restrictions={restrictions} />
                                    </Modal>
                                : null}
                            </div>
                        </SidebarSection>
                    </main>
                :
                    <div className="loading"><Trans>Daten werden geladen ...</Trans></div>
                }

                {((allOptions.length !== 0) && (selected)) ?
                    window.b2b ?
                        <BuyBoxB2B selected={selected} />
                    :
                        <BuyBoxB2C selected={selected} />
                : ''}

            </aside>
        </div>
    )

}

export default Main
